// hooks/useLocations.ts
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { logAndThrow } from '../utils/logging';

export type LocationRow = {
    id: string;
    wilaya: string | null;
    daira: string | null;
    commune: string | null;
    latitude: number | null;
    longitude: number | null;
    wilaya_ar: string | null;
    daira_ar: string | null;
    commune_ar: string | null;
};

export const LOCATIONS_QUERY_KEY = ['locations'] as const;

async function fetchLocations(): Promise<LocationRow[]> {
    const { data, error } = await supabase
        .from('locations')
        .select('id, wilaya, daira:dairas, commune:communes, latitude, longitude, wilaya_ar, daira_ar, commune_ar')
        .limit(3000);

    if (error) return logAndThrow('fetch locations', error);
    return data || [];
}

export const createLocationsQueryOptions = () => ({
    queryKey: LOCATIONS_QUERY_KEY,
    queryFn: fetchLocations,
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 7 * 24 * 60 * 60 * 1000,
});

export function useLocations(options: { enabled?: boolean } = {}) {
    return useQuery({
        ...createLocationsQueryOptions(),
        enabled: options.enabled ?? true,
    });
}
